import { useIsDomReady } from "@/hooks/IsDomReady";
import useInteractionStart from "@/hooks/useInteractionStart";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { usePathname, useSearchParams } from "next/navigation";

const useShouldFire = () => {
  const { isInteracting } = useInteractionStart();
  const isDomReady = useIsDomReady();
  const quaryParams = useSearchParams();
  const pathName = usePathname();
  const isCheckoutResultPage = pathName.includes(PagesPaths.checkoutResult);
  const track_id = quaryParams.get("track_id");
  const shouldFire = !(track_id || isCheckoutResultPage)
    ? isInteracting
    : isDomReady;
  return shouldFire;
};

export default useShouldFire;
